import { Suspense } from "react";
import ProfilePage from "@/app/profile/profile";

export default function ProfilePageWrapper() {
  return (
    <Suspense>
      <ProfilePage />
    </Suspense>
  );
}
